import {isDiyiSdk} from "@/appApi";

let appId = process.env.VUE_APP_THINKING_DATA_ID;
if (navigator.userAgent.toLowerCase().indexOf('talkjoy')!== -1) {
    appId = process.env.VUE_APP_TALK_THINKING_DATA_ID;
}
/* eslint-disable */
(function(param) {
    var p = param.sdkUrl, n = param.name, w = window, d = document, s = 'script',x = null,y = null;
    w['ThinkingDataAnalyticalTool'] = n;
    w[n] = w[n] || function(a) {return function() {(w[n]._q = w[n]._q || []).push([a, arguments]);}};
    var methods = ['track','quick','identify','login','logout','trackLink','userSet','userSetOnce','userAdd','userDel','setPageProperty'];
    for (var i = 0; i < methods.length; i++) {
        w[n][methods[i]] = w[n].call(null, methods[i]);
    }
    if (!w[n]._t) {
        x = d.createElement(s), y = d.getElementsByTagName(s)[0];
        x.defer = 1;
        x.src = p;
        y.parentNode.insertBefore(x, y);
        w[n].param = param;
    }
})({
    appId,
    name: 'g_tga',     //全局的调用变量名，可以任意设置，后续的调用使用该名称即可
    sdkUrl: 'https://s.diyiedu.com/thinkingdata.js',   //统计脚本URL
    serverUrl: 'https://dataup.diyiedu.com/sync_js',  //数据上传的URL
    send_method: 'image',        //数据上传方式
    useAppTrack: true, // 打通 APP 与 H5
    showLog: process.env.VUE_APP_THINKING_DATA_DEBUG    //是否打印上报数据
});


